import dayjs from 'dayjs';

const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
const MONTH_SHORT = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

const taskWord = (count, one, few, many) => {
    const n10 = count % 10;
    const n100 = count % 100;
    if (n10 === 1 && n100 !== 11) return one;
    if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
    return many;
};

export const activitySummary = (total, year, rolling = false) => {
    const word = taskWord(total, 'задача завершена', 'задачи завершены', 'задач завершено');
    return rolling ? `${total} ${word} за последний год` : `${total} ${word} в ${year}`;
};

// Текущий год и все предыдущие, в которых есть завершённые задачи
export const activityYears = (days, now = dayjs()) => {
    const current = now.year();
    let earliest = current;
    (days ?? []).forEach((day) => {
        const year = Number(String(day.day).slice(0, 4));
        if (year > 1900 && year < earliest) earliest = year;
    });
    const years = [];
    for (let year = current; year >= earliest; year -= 1) years.push(year);
    return years;
};

export const activityTooltip = (count, date) => {
    const label = `${date.date()} ${MONTHS[date.month()]} ${date.year()}`;
    if (!count) return `Нет завершённых задач, ${label}`;
    const word = taskWord(count, 'задача', 'задачи', 'задач');
    return `${count} ${word}, ${label}`;
};

// 0 — нет задач, 1–4 — доля от максимума за год
export const activityLevel = (count, max) => {
    if (count <= 0 || max <= 0) return 0;
    if (max <= 1) return 1;
    if (count >= max) return 4;
    return Math.min(4, Math.max(1, Math.ceil((count / max) * 4)));
};

// Текущий год — последние 12 месяцев от сегодня. Прошлый — календарный год.
// Неделя с воскресенья, дни вне окна и будущие — пустые.
export const buildActivityWeeks = (days, year, now = dayjs()) => {
    const today = now.startOf('day');
    const rolling = year === today.year();
    const from = rolling ? today.subtract(1, 'year') : dayjs(`${year}-01-01`).startOf('day');
    const endOfRange = rolling ? today : dayjs(`${year}-12-31`).startOf('day');
    const start = from.subtract(from.day(), 'day');
    const end = endOfRange.add(6 - endOfRange.day(), 'day');
    const counts = new Map((days ?? []).map((d) => [String(d.day).slice(0, 10), d.count]));
    const weeks = [];
    for (let cursor = start; !cursor.isAfter(end); cursor = cursor.add(7, 'day')) {
        const cells = [];
        for (let dow = 0; dow < 7; dow += 1) {
            const date = cursor.add(dow, 'day');
            const key = date.format('YYYY-MM-DD');
            const outside = rolling ? date.isBefore(from, 'day') : date.year() !== year;
            const hidden = outside || date.isAfter(today);
            cells.push({
                key,
                date,
                count: hidden ? 0 : (counts.get(key) || 0),
                outside,
                future: hidden,
            });
        }
        weeks.push(cells);
    }
    const max = weeks.reduce((acc, week) => week.reduce((m, cell) => Math.max(m, cell.count), acc), 0);
    const total = weeks.reduce((acc, week) => week.reduce((sum, cell) => sum + cell.count, acc), 0);
    return { weeks, max, total };
};

export const activityMonthLabels = (weeks) => {
    let last = -4;
    return weeks.map((week, index) => {
        const first = week.find((cell) => cell.date.date() === 1 && !cell.outside);
        if (!first || index - last < 3) return '';
        last = index;
        return MONTH_SHORT[first.date.month()];
    });
};
